import { ResurrectionBanner } from 'growth-feature-usage-components';
import { treatmentsPromise, laboratoryClient } from 'dashboard-ui-components/js/data/laboratoryClient';
import { jsx as _jsx } from "react/jsx-runtime";
export const ResurrectionBannerExperiment = () => {
  return /*#__PURE__*/_jsx(ResurrectionBanner, {
    featureLimitName: "dashboards",
    treatments: treatmentsPromise,
    logExposure: laboratoryClient.logExposure
  });
};